// apiHelpers.js
import axios from "axios";

export async function fetchWithAuth(url, token) {
    return await axios.get(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export async function postWithAuth(url, data, token, params = {}) {
    return await axios.post(url, data, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params,
    });
}

export async function deleteWithAuth(url, token) {
    return await axios.delete(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export async function putWithAuth(url, data, token) {
    return await axios.put(url, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}